import React from 'react'

const Footer = () => (
<footer className="container footer text-center">
  <p>&copy; {new Date().getFullYear()} <a href="https://brandonstephens.me">Brandon Stephens</a> | Subscribe <a href="/feed.xml">via RSS</a></p>
</footer>
)

export default Footer
